<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-04-28 16:41:15
 * @LastEditTime: 2019-07-04 16:35:23
 * @LastEditors: 长老
 -->
<template>
  <div class="brand-list-view root-box" :class="{ showNavBar }">
    <!-- 顶部页签 -->
    <top-meta titleName="品牌" @lastPage="lastPage"></top-meta>
    <!-- 水平导航栏 -->
    <menu-nav v-show="!menuIsNull"></menu-nav>
    <!-- 商品区 -->
    <commodity-group v-show="!brandIsNull"></commodity-group>
    <no-result v-show="menuIsNull || brandIsNull" :status="status" @reloadData="reloadData"></no-result>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('brandList')
import YunJi from '@/assets/js/YunJi'
import TopMeta from '@/pages/commodity/components/topMeta'
import MenuNav from './components/MenuNav'
import CommodityGroup from './components/CommodityGroup'
import NoResult from '@/pages/commodity/components/NoResult/NoResult'

export default {
  components: {
    TopMeta,
    MenuNav,
    CommodityGroup,
    NoResult
  },
  data() {
    return {
      showNavBar: YunJi.showNavBar()
    }
  },
  computed: {
    ...mapState({
      menuIsNull: state => state.menuData.length == 0,
      brandIsNull: state => state.brandList.length == 0,
      status: state => state.isReq ? 3 : state.isErr ? 2 : 1
    }),
  },
  methods: {
    ...mapActions(['queryBrandList', 'queryBrandMenu']),
    lastPage() {
      history.back()
    },
    reloadData() {
      if(this.menuIsNull) {
        this.queryBrandMenu()
      } else {
        this.queryBrandList()
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../style/common.less';
.brand-list-view{
  /deep/ .category-noResult{
    height: auto;
    flex: 1;
    background-color: #f2f2f2;
    .reload-btn{
      background-color: #fff; 
    }
  }
}
</style>
<style lang="less">
html,body,#main{
  height: 100%;
}
::-webkit-scrollbar{
  width: 0;
}
</style>